import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSOCEarnings } from "../../services/dashboards/score-insights.services/dashboards-crud.services";

export const fetchSOCEarnings = createAsyncThunk("admin/SOC_Earnings/fetch", async (_, { rejectWithValue }) => {
	try {
		const { data } = await getSOCEarnings();
		return data.soc_earnings;
	} catch (err) {
		return rejectWithValue(err.response?.data ?? { error: "Network or server error" });
	}
});

const initialState = {
	earnings: [],
	status: "unset",
	error: null,
};

const socEarningsSlice = createSlice({
	name: "admin/SOC_Earnings",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchSOCEarnings.pending, (state) => {
				state.status = "loading";
				state.error = null;
			})
			.addCase(fetchSOCEarnings.fulfilled, (state, action) => {
				state.status = "succeeded";
				state.earnings = action.payload;
			})
			.addCase(fetchSOCEarnings.rejected, (state, action) => {
				state.status = "failed";
				state.error = action.payload?.error || action.error.message;
			});
	},
});

export default socEarningsSlice.reducer;
